import type React from "react";

import {type GameObjectType, config} from "@repo/shared";

import CustomButton from "~/component/common/CustomButton";
import {cld} from "~/firebase/cloudinary";
import {useSelection} from "~/three/selection/useSelection";

interface GameObjectModalContentProps {
  closeModal: () => void;
}

const GameObjectContent: React.FC<GameObjectModalContentProps> = ({
  closeModal,
}) => {
  const {currentGameObjectType} = useSelection();
  const handleSelection = (type: string) => {
    currentGameObjectType.current = type as GameObjectType;
    closeModal();
  };

  return (
    <div className="rounded-lg shadow-lg max-w-md mx-auto">
      <h2 className="text-xl mb-4 text-white">Select</h2>
      <div className="space-y-4">
        {Object.entries(config.objectTypes).map(([type, value]) => (
          <CustomButton
            key={type}
            onClick={() => handleSelection(type)}
            className="flex flex-col items-start p-2 rounded-md cursor-pointer bg-gray-800 hover:bg-gray-500 transition w-full"
          >
            <div className="flex items-center w-full">
              <img
                src={cld
                  .image(value.image)
                  .format("auto")
                  .quality("auto")
                  .toURL()}
                alt={value.displayName}
                className="w-10 h-10 rounded"
              />
              <span className="ml-2 text-white text-lg">
                {value.displayName}
              </span>
            </div>
            <div className="text-gray-100 text-sm mt-2">
              {value.description}
            </div>
          </CustomButton>
        ))}
      </div>
    </div>
  );
};

export default GameObjectContent;
